import { render, staticRenderFns } from "./ScopeModal.vue?vue&type=template&id=dbd7086a&"
import script from "./ScopeModal.vue?vue&type=script&lang=ts&"
export * from "./ScopeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports